import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import { Item, Input, Select } from 'semantic-ui-react'
import { ISO_FORMAT } from '../helpers/dateHelpers'
import {
  YESTERDAY,
  TODAY,
  TOMORROW,
  THIS_WEEK,
  ALL_TIME,
  SINGLE_DATE,
  DATE_RANGE,
  DATE_ATTR_APPT_TIME,
  DATE_ATTR_CREATED_AT
} from '../constants/search_filters'

const DATE_TYPES = [
  { text: 'Yesterday', value: YESTERDAY, key: `date-type-${YESTERDAY}` },
  { text: 'Today', value: TODAY, key: `date-type-${TODAY}` },
  { text: 'Tomorrow', value: TOMORROW, key: `date-type-${TOMORROW}` },
  { text: 'This Week', value: THIS_WEEK, key: `date-type-${THIS_WEEK}` },
  { text: 'All Time', value: ALL_TIME, key: `date-type-${ALL_TIME}` },
  { text: 'Single Date', value: SINGLE_DATE, key: `date-type-${SINGLE_DATE}` },
  { text: 'Date Range', value: DATE_RANGE, key: `date-type-${DATE_RANGE}` }
]

const DATE_ATTR_OPTIONS = [
  { key: 'Appt time', text: 'Appointment Time', value: DATE_ATTR_APPT_TIME },
  { key: 'Created at', text: 'Created At', value: DATE_ATTR_CREATED_AT }
]

class DateFilters extends React.Component {
  updateFilterStore = (data) => {
    this.props.dispatch({
      type: 'SHOP_ORDER_FILTERS_UPDATE',
      payload: data
    })
  }

  datesState = () => {
    const { start_date, end_date, date_type } = this.props
    return { start_date, end_date, date_type }
  }

  handleDateSelection = (e) => {
    const formattedDate = moment(e.target.value, ['MM-DD-YYYY', 'MM-DD-YY', 'M-D-YY', ISO_FORMAT])
    const newState = this.datesFromDateType({ ...this.datesState(), [e.target.name]: formattedDate })
    this.updateFilterStore(newState)
  }

  handleDateTypeSelection = (e, selection) => {
    const value = selection.value
    const requestedDates = this.datesFromDateType({ ...this.datesState(), date_type: value })
    this.updateFilterStore({ date_type: value, ...requestedDates })
  }

  handleDateAttrSelection = (e, selection) => {
    this.updateFilterStore({ date_attr: selection.value })
  }

  datesFromDateType(state = this.datesState()) {
    const { date_type, start_date, end_date } = state

    return {
      [YESTERDAY]: { start_date: moment().subtract(1, 'days'), end_date: moment().subtract(1, 'days') },
      [TODAY]: { start_date: moment(), end_date: moment() },
      [TOMORROW]: { start_date: moment().add(1, 'days'), end_date: moment().add(1, 'days') },
      [THIS_WEEK]: { start_date: moment().weekday(0), end_date: moment().weekday(6) },
      [SINGLE_DATE]: { start_date: start_date, end_date: start_date },
      [DATE_RANGE]: { start_date: start_date, end_date: end_date },
      [ALL_TIME]: { start_date: undefined, end_date: undefined }
    }[date_type] || {}
  }

  datePickerNeeded(value = this.props.date_type) {
    return [SINGLE_DATE, DATE_RANGE].includes(value)
  }

  displayDates() {
    const { start_date, end_date, date_type } = this.props
    if ([YESTERDAY, TODAY, TOMORROW, THIS_WEEK].includes(date_type) && start_date && end_date) {
      return `${start_date.format('M/D/YY')} - ${end_date.format('M/D/YY')}`
    }
    else {
      return ''
    }
  }

  render() {
    const { date_type, date_attr } = this.props

    return (
      <Item style={{maxWidth: '228px'}}>
        <div>
          <span><b>Time Range:</b></span>
          <span style={{paddingTop: '.5rem', marginLeft: '.5rem'}}>
            <small>{this.displayDates()}</small>
          </span>
          <span>
          <small>
            <div style={{marginTop: '10px', marginBottom: '3px'}}>Scope time by:</div>
            <Select
              selection
              onChange={this.handleDateAttrSelection}
              value={date_attr}
              options={DATE_ATTR_OPTIONS}
              style={{marginTop: '3px'}}
            />
          </small>
          </span>
        </div>

        <Select
          options={DATE_TYPES}
          onChange={this.handleDateTypeSelection}
          value={date_type}
          style={{marginTop: '10px', marginRight: 0}}
        />

        {this.datePickerNeeded() &&
          <Fragment>
            <Input
              name="start_date"
              type="date"
              onChange={this.handleDateSelection}
              style={{marginTop: "10px"}}
              placeholder={'mm/dd/yyyy'}
            />
            {this.props.date_type === DATE_RANGE &&
              <Input
                name="end_date"
                type="date"
                onChange={this.handleDateSelection}
                style={{marginTop: "10px"}}
                placeholder={'mm/dd/yyyy'}
              />
            }
          </Fragment>
        }
      </Item>
    )
  }
}

const mapStateToProps = (state) => {
  const filters = state.shopOrderFilters.currentFilters || {}
  const { start_date, end_date, date_attr, date_type } = filters

  return {
    start_date: start_date,
    end_date: end_date,
    date_attr: date_attr,
    date_type: date_type
  }
}

export default connect(mapStateToProps)(DateFilters)
